<template>
  <div>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top: 10px"
      @click="StoreTypeDialog = true"
      v-if="sort_data == false && !isEditStoreList"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <StoreTypeForm
      :dialog="StoreTypeDialog"
      :editedIndex="editedIndex"
      @cancel="cancelADDEDIT($event)"
      @save="saveADDEDIT($event)"
      @close="StoreTypeDialog = false"
      :selectedItem="selectedItem"
    />
    <v-layout row wrap>
      <v-flex xs6 class="text-xs-left">
        <v-toolbar dense flat v-if="sort_data == false">
          <v-btn @click="startSort()" round dark v-if="!isEditStoreList"
            >Start sort</v-btn
          >
        </v-toolbar>
      </v-flex>
      <v-flex xs6 v-if="sort_data == false">
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 v-if="sort_data == true">
        <v-toolbar dense flat>
          <v-btn
            @click="cancelSortData()"
            :loading="cancel_sort"
            :disabled="cancel_sort || sorting_data"
            color="red"
            >Cancel</v-btn
          >
          <label v-if="sort_msg == 3">Cant sort</label>
          <v-btn
            @click="sortData()"
            :loading="sorting_data"
            :disabled="sorting_data || cancel_sort"
            color="green"
            >Apply sort</v-btn
          >
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :loading="loading_message"
      :items="types.store_types"
      :search="search"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="px-1 handle" style="width: 0.1%" v-if="sort_data == true">
          <v-btn style="cursor: move" icon :disabled="sorting_data">
            <v-icon>drag_indicator</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center" v-else>{{ countIndex(props.item) }}</td>
        <td style="padding: 6px 0 0 0">
          <img :src="props.item.store_type_image" width="50px" height="50px" />
        </td>
        <td class="text-xs-center">{{ props.item.store_type_name_th }}</td>
        <td class="text-xs-center">{{ props.item.store_type_name_en }}</td>
        <td class="text-xs-center">{{ props.item.store_type_name_cn }}</td>
        <td class="text-xs-center">{{ typeService(props.item) }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top v-if="sort_data == false">
            <v-btn
              :disabled="isEditStoreList"
              icon
              @click="editStoreType(props.item, props.index)"
              slot="activator"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top v-if="sort_data == false">
            <v-btn
              icon
              @click="deleteStoreType(props.item)"
              :disabled="isEditStoreList"
              slot="activator"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loading_message == false">
          <div>No data available</div>
          <div>
            <v-btn @click="initialize()">Reset</v-btn>
          </div>
        </div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import StoreTypeForm from "./StoreTypeForm.vue";
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    pagination: { rowsPerPage: 10 },
    cancel_sort: false,
    sort_msg: 0,
    data_for_sort: {},
    sort_data: false,
    sorting_data: false,
    search: "",
    loading_message: false,
    selected: [],
    original_data: null,
    store_type_img: [],
    selectedItem: {
      store_type_name_th: null,
      store_type_name_en: null,
      store_type_name_cn: null,
      store_type_service_id: null,
    },
    StoreTypeDialog: false,
    dialog: false,
    editedIndex: -1,
    headers: [
      {
        text: "No.",
        align: "center",
        value: "index",
        sortable: false,
      },
      {
        text: "Icon",
        align: "center",
        sortable: false,
      },
      {
        text: "Store Type Name TH",
        value: "store_type_name_th",
        align: "center",
        sortable: false,
      },
      {
        text: "Store Type Name EN",
        align: "center",
        value: "store_type_name_en",
        sortable: false,
      },
      {
        text: "Store Type Name CN",
        align: "center",
        value: "store_type_name_cn",
        sortable: false,
      },
      {
        text: "Store Service Name TH",
        value: "store_type_service_name",
        align: "center",
        sortable: false,
      },
      // {
      //   text: "Popular type",
      //   align: "center",
      //   sortable: false
      // },
      {
        text: "Actions",
        align: "center",
        sortable: false,
      },
    ],
  }),
  components: {
    StoreTypeForm,
  },
  computed: {
    ...mapState({
      types: (state) => state.fetchStoreBack.store_type,
      load_edit_index: (state) => state.fetchStoreBack.load_edit_index,
    }),
    ...mapGetters(["isEditStoreList"]),
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },
  mounted() {
    let table = document.querySelector(".v-datatable tbody");
    const _self = this;
    Sortable.create(table, {
      handle: ".handle",
      onEnd({ oldIndex, newIndex }) {
        const rowSelected = _self.data_for_sort.splice(oldIndex, 1)[0];
        _self.data_for_sort.splice(newIndex, 0, rowSelected);
      },
    });
  },
  methods: {
    countIndex(item) {
      return this.types.store_types.indexOf(item) + 1;
    },
    startSort() {
      this.data_for_sort = JSON.parse(JSON.stringify(this.types.store_types));
      this.sort_data = true;
    },
    async cancelSortData() {
      this.cancel_sort = true;
      await this.getNewData();
      this.cancel_sort = false;
      this.data_for_sort = {};
      this.sort_data = false;
      this.sort_msg = 0;
    },
    async sortData() {
      this.sorting_data = true;
      let obj1 = JSON.parse(JSON.stringify(this.data_for_sort));
      for (let key in obj1) {
        delete obj1[key].store_type_image;
        delete obj1[key].store_type_name_cn;
        delete obj1[key].store_type_name_en;
        delete obj1[key].store_type_name_th;
        delete obj1[key].store_type_popular;
        delete obj1[key].store_type_service_id;
        delete obj1[key].store_type_service_name;
        obj1[key].store_type_series = parseFloat(key) + 1;
      }

      this.sort_msg = await this.$store.dispatch(
        "fetchStoreBack/SortStore",
        obj1
      );
      if (this.sort_msg != 3) {
        this.$store.commit("fetchStoreBack/getDataType", []);
        await this.initialize();
        this.sort_data = false;
      }
      this.sorting_data = false;
    },
    deleteStoreType(item) {
      confirm("Are you sure you want to delete this user?") &&
        this.$store.dispatch("fetchStoreBack/deleteStoreType", item);
    },
    saveADDEDIT(event) {
      this.StoreTypeDialog = false;
      this.editedIndex = -1;
      this.selectedItem = {
        store_type_name_th: null,
        store_type_name_en: null,
        store_type_name_cn: null,
        store_type_service_id: null,
      };
      event.form.resetValidation();
    },
    cancelADDEDIT(event) {
      this.StoreTypeDialog = false;
      if (this.editedIndex != -1) {
        Object.assign(this.selectedItem, this.original_data);
        this.original_data = null;
      }
      this.editedIndex = -1;
      this.selectedItem = {
        store_type_name_th: null,
        store_type_name_en: null,
        store_type_name_cn: null,
        store_type_service_id: null,
      };
      event.form.resetValidation();
    },
    typeService(item) {
      for (let key in this.types.store_services) {
        if (
          this.types.store_services[key].store_service_id ==
          item.store_type_service_id
        ) {
          item.store_type_service_name = this.types.store_services[
            key
          ].store_service_name_th;
        }
      }
      return item.store_type_service_name;
    },
    async getNewData() {
      this.$store.commit("fetchStoreBack/getDataType", []);
      await this.$store.dispatch("fetchStoreBack/getDataType");
    },
    async initialize() {
      this.loading_message = true;
      await this.$store.dispatch("fetchStoreBack/getDataType");
      this.loading_message = false;
    },
    editStoreType(item, index) {
      this.original_data = Object.assign({}, item);
      this.selectedItem = item;
      this.StoreTypeDialog = true;
      this.editedIndex = index;
    },
  },
};
</script>

<style scoped>
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>
